import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AppService } from 'app/app.service';
import { CostantiStorage } from 'app/main/utils/costanti';
import { UtentiService } from 'app/main/utils/service/utente.service';
import { SessioneUtenteQuery, SessioneUtenteStore } from 'app/main/utils/state';
import { environment } from 'environments/environment';

@Component({
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatRippleModule],
  selector: 'app-switch',
  templateUrl: './app-switch.component.html',
  styleUrls: ['./app-switch.component.scss']
})
export class AppSwitchComponent implements OnInit {
  private destroy$ = new Subject<void>();
  utente;
  isMobile;

  constructor(
    private utenteService: UtentiService,
    private appService: AppService,
    private sessioneUtenteStore: SessioneUtenteStore,
    private sessioneUtenteQuery: SessioneUtenteQuery,
    platform: Platform
  ) {
    this.utente = sessioneUtenteQuery.loggedUser();
    this.isMobile = platform.ANDROID || platform.IOS;
  }
  isAnagraficaVisibile() {
    return this.utente && this.utente.tipo_utente !== 4 && this.utente.tipo_utente !== 6;
  }
  ngOnInit() {
    this.appService.onReloadSwitch.pipe(takeUntil(this.destroy$)).subscribe(reload => {
      if (reload) {
        this.utente = this.sessioneUtenteQuery.loggedUser();
      }
    });
  }

  switchApp(app) {
    this.utenteService
      .switchPreLogin()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (!data['error']) {
          const versionApp = localStorage.getItem(CostantiStorage.VERSION);
          this.appService.clearState();
          localStorage.clear();
          this.sessioneUtenteStore.logout();
          if (versionApp) {
            localStorage.setItem(CostantiStorage.VERSION, versionApp);
          }
          switch (app) {
            case 'ana':
              window.location.href = environment.urlPreLoginAnagrafica + '/' + data['response'];
              break;
            case 'soc':
              window.location.href = environment.urlPreLoginSocial + '/' + data['response'];
              break;
            case 'ser':
              window.location.href = environment.urlPreLoginServizi + '/' + data['response'];
              break;
          }
        } else {
          console.error('1');
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }
}
